<template>
    <div class="main">
        <header class="">
            <el-form ref="formSearch" :inline="true" label-width="100px">
                <!-- <el-form-item label="状态" label-width="auto;">
                    <el-select v-model="cycle">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未下载" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="提交时间" label-width="auto;">
                    <el-date-picker
                        v-model="dealTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <a
                        class="imitate-el_btn"
                        :href="
                            '/fep/pc/workroomCompanyIn/exportExcel?ids=' +
                                multipleSelection.map((rs) => {
                                    return rs.id;
                                })
                        "
                        download="1"
                        >{{
                            multipleSelection.length == 0
                                ? "全部导出"
                                : "选择导出"
                        }}</a
                    >
                </el-form-item>
            </el-form>
        </header>
        <div style="color: #777777; font-size: 13px">
            提示：仅支持导出当前页面所选的数据，不支持跨页导出
            <!-- <span
                >已选择:{{
                    multipleSelection.map((rs) => {
                        return rs.id;
                    })
                }}</span
            > -->
        </div>

        <el-table
            ref="multipleTable"
            :data="tableData"
            border
            stripe
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            :row-class-name="tableRowClassName"
        >
            <el-table-column type="selection" width="40px"> </el-table-column>
            <el-table-column prop="id" label="编号" width="500px">
            </el-table-column>
            <el-table-column label="提交时间" width="460px">
                <template slot-scope="scope">{{
                    scope.row.createTime
                }}</template>
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalPage"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { rap, fetch } from "@/utils/common.js";

let url = {
    profile: "/fep/pc/user/profile",
    download: "/fep/pc/workroomCompanyIn/exportExcel",
    list: "/fep/pc/workroomCompanyIn/list",
};
export default {
    components: {},
    props: [],
    data() {
        return {
            tLoading: true,
            total: 0,
            pageNo: 1,
            pageSize: 10,
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            dealTime: "",
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        fetch(url.profile).then((res) => {});

        this.getList();
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.cycle === 2) {
                return "d-sel";
            }
            return "";
        },
        clickDownload() {
            let arr = this.multipleSelection
                .map((rs) => {
                    return rs.id;
                })
                .join(",");

            let data = {
                ids: arr.join(","),
            };
            fetch(url.download, data).then(
                (res) => {
                    if (res.status === 200) {
                    }
                },
                (res) => {
                    this.$message.error(res.message);
                }
            );
        },

        getList() {
            let beginDate = "";
            let endDate = "";
            if (this.dealTime != "" && this.dealTime != null) {
                let dateBegin = new Date(this.dealTime[0]);
                let dateEnd = new Date(this.dealTime[1]);
                beginDate = `${dateBegin.getFullYear()}-${dateBegin.getMonth() +
                    1}-${dateBegin.getDate()}`;
                endDate = `${dateEnd.getFullYear()}-${dateEnd.getMonth() +
                    1}-${dateEnd.getDate()}`;
            }
            let data = {
                beginDate,
                endDate,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            };

            fetch(url.list, data).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data.list;
                    this.totalPage = res.data.totalRow;
                }
            });
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNo = val;
            this.getList();
        },
    },
};
</script>
<style>
#app {
    overflow: auto !important;
}
.el-form-item__label {
    color: #888;
    padding-right: 8px;
    white-space: normal !important;
}
.main {
    width: 1000px;
    padding: 20px;
    margin: 30px auto 30px;
    border: 1px solid #f7f7f7;
    background: #fcfcfc;
    box-shadow: rgb(230, 240, 240, 0.6) 5px 2px 40px 5px;
}
.d-sel {
    color: rgb(223, 217, 217);
}
</style>
